module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/quality-measures/remoteEntry.js';
            script.onload = () => { resolve(window['qualityMeasures']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module qualityMeasures unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });